import RuleFormPage from './Create';
import DetailRule from './Detail';
import DispatchDeviationRule from './index';

const routes = [
  {
    path: '/dispatch/control/deviation-rule',
    element: <DispatchDeviationRule />,
  },
  {
    path: '/dispatch/control/deviation-rule/create',
    element: <RuleFormPage />,
  },
  {
    path: '/dispatch/control/deviation-rule/:id/edit',
    element: <RuleFormPage isEdit />,
  },
  {
    path: '/dispatch/control/deviation-rule/:id/view',
    element: <DetailRule />,
  },
];

export default routes;
